import React from 'react';
import RangeFilterPlain from './shared/RangeFilterPlain/RangeFilterPlain';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../../../util/urlHelpers';

const SEARCH_PARAM = 'beam';

import css from './SearchPageStyles.module.css';

const WidthFilter = () => {
  const intl = useIntl();
  const history = useHistory();
  const { location } = history;

  const currentQueryParams = parse(location?.search);

  return (
    <RangeFilterPlain
      className={css.draughtFilter}
      id="widthFilter"
      label={intl.formatMessage({ id: 'EditListingDetailsForm.width' })}
      queryParamNames={SEARCH_PARAM}
      initialValues={{ width: currentQueryParams.width }}
      min={0}
      max={1000}
      unit="m"
      showTrigger={false}
      liveEdit={true}
      compactFilter
    />
  );
};

export default WidthFilter;
